import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaPlus, FaRegFile, FaTrashAlt } from 'react-icons/fa';
import { useU2000AuthContext } from '../../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000FormStateHandlersReturn } from '../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import { U2000FormStateEnumState } from '../../../../u2000Core/reducer/formReducer/U2000FormState';
import { NS, U3151ROLES } from '../../../U3151';
import type { U3151CustomerTypeFormRow } from '../../../U3151Service';

export type U3151CustomerTypeFormToolbarHandlers = U2000FormStateHandlersReturn<U3151CustomerTypeFormRow> & {
  addNewCustomerType: () => void;
  modifyCustomerType: () => void;
  deleteCustomerType: () => void | Promise<void>;
};

interface U3151CustomerTypeFormToolBarProps {
  formStateHandlers: U3151CustomerTypeFormToolbarHandlers;
}

export const U3151CustomerTypeFormToolBar: React.FC<U3151CustomerTypeFormToolBarProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: 'add',
      label: t('btnAdd', { ns: NS }),
      hasRole: hasRole(U3151ROLES.ADD),
      handleClick: () => {
        formStateHandlers.addNewCustomerType();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U3151ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyCustomerType();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: NS }),
      hasRole: hasRole(U3151ROLES.DELETE),
      handleClick: () => {
        formStateHandlers.deleteCustomerType();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
